import generate from 'app/xEcoApm/event/report/generate'

/**
 * If the `autoReported` flag is not set, it sets it and calls {@link generate}.
 */
const generateReport = (obj: Gaia.AppModule.Spec) => async (...args: unknown[]) => {
  const actionState = obj[G.STATE][G.ACTION][G.STATE]

  if (!actionState.autoReported) {
    actionState.autoReported = true

    try {
      await generate(obj, null, null)
    } catch(error) {
      delete actionState.autoReported
      console.error(error)
    }
  }

  return args
}

export default generateReport
